import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import styles from "./styles";

function IconButton(props) {
  const {
    Icon,
    onClick,
    disabled,
    color
  } = props;

  const classes = styles(props);

  let className = props.className
    ? clsx(classes.iconButton, props.className)
    : classes.iconButton;

  return (
    <Icon
      className={className}
      onClick={e => disabled ? null : onClick(e)}
      disabled={disabled}
      color={disabled ? "disabled" : color}
    />
  )
}

IconButton.propTypes = {
  Icon: PropTypes.oneOfType([
    PropTypes.elementType,
    PropTypes.element,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf([
    "inherit",
    "primary",
    "secondary",
    "action",
    "error",
    "disabled"
  ]),
  className: PropTypes.string
}

IconButton.defaultProps = {
  disabled: false,
  color: "inherit"
}

export default IconButton;
